import { render } from "./PostCommentButton.vue?vue&type=template&id=8f08f426"
import script from "./PostCommentButton.vue?vue&type=script&lang=js"
export * from "./PostCommentButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__